import './_common.js';
import '../css/recommended.scss';
import { setupContactForm } from './ui-part/contact-form.js';
import './ui-part/iframe-calendar.js';
import './ui-part/assistant-tooltip.js';
import './ui-part/user-template.js';

function setupMobileHashChangeFix()
{
    let nav = document.querySelector('.navbar-mobile');
    let toggler = document.querySelector('.navbar-toggler');

    nav.addEventListener('click', event => {
        if ('A' !== event.target.tagName) {
            return;
        }

        let anchor = event.target;

        let isNavOpen = nav.classList.contains('open');
        let isAnchorHash = anchor.hash;

        if (isNavOpen && isAnchorHash) {
            event.preventDefault();
            toggler.click();

            let clickCallback = () => {
                anchor.click();
                nav.removeEventListener('transitionend', clickCallback);
            };
            nav.addEventListener('transitionend', clickCallback);
        }
    });
}

function attachRecaptchaScript() {
    let tag = 'script';
    let scriptId = 'google-recaptcha';
    let js, fjs = document.getElementsByTagName(tag)[0];
    if (document.getElementById(scriptId)) return;
    js = document.createElement(tag); js.id = scriptId;
    js.src = 'https://www.google.com/recaptcha/api.js?hl=' + document.querySelector('.contact-form').dataset.locale;
    fjs.parentNode.insertBefore(js, fjs);
}

function setupRecaptcha() {
    const target = document.querySelector('.contact-form');

    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    observer.unobserve(target);
                    attachRecaptchaScript();
                }
            });
        },
        {
            root: null,
            threshold: 0,
        }
    );

    observer.observe(target);
}

window.addEventListener('DOMContentLoaded', () => {
    setupContactForm();
    setupMobileHashChangeFix();
    setupRecaptcha();
});
